import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function PrivateRoute({ children }) {
	const { user, loading } = useAuth();
	if (loading) {
		return (
			<div className="pt-20 md:pt-24 min-h-screen flex items-center justify-center" data-testid="auth-loading">
				<div className="w-8 h-8 border-2 border-[#1A3C34] border-t-transparent rounded-full animate-spin" />
			</div>
		);
	}
	if (!user) return <Navigate to="/auth" replace />;
	return children;
}